import React from 'react';
import { View, StyleSheet, Image } from 'react-native';
import { useHistory } from 'react-router';

import { Text, Button } from '../core-ui';
import { WHITE_TWO, CAPTION_TEXT } from '../constants/colors';

import { pageNotFound } from '../../assets';

export default function NotFound() {
  let history = useHistory();
  let onGoBackPressed = () => {
    history.push('/');
  };

  return (
    <View style={styles.container}>
      <Image source={pageNotFound} style={styles.image} />
      <Text type="header" style={styles.oopsText}>
        Oops... You might be lost.
      </Text>
      <Text color={CAPTION_TEXT} style={styles.captionText}>
        Sorry, the resource you are looking for may have been relocated or even
        removed from this site.
      </Text>
      <Button title="Go Back Home" onPress={onGoBackPressed} />
    </View>
  );
}

const styles = StyleSheet.create({
  container: {
    flex: 1,
    alignItems: 'center',
    justifyContent: 'center',
    backgroundColor: WHITE_TWO,
  },
  oopsText: {
    fontSize: 26,
    marginBottom: 16,
  },
  captionText: {
    marginBottom: 28,
  },
  image: {
    width: 480,
    height: 320,
    marginBottom: 42,
  },
});
